// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"0f586dd6","453":"b14109fd","527":"f34beeb2"}[chunkId] + ".chunk.js";
};